import { LogoFCCopenhagen } from "src/components/LogoFCCopenhagen";
import { color2 } from "../../styles";
import { Flavor } from "./flavor";
import { IFeatureFlags } from "../../../../shared/interface";

class FCCopenhagenFlavor extends Flavor {
  getMainColor() {
    return color2.FCCOPENHAGEN;
  }

  getDashLineColor() {
    return color2.FCCOPENHAGEN;
  }

  getCircleLogo() {
    return <LogoFCCopenhagen />;
  }

  getFeatureFlags(): IFeatureFlags {
    return {
      ...super.getFeatureFlags(),
      contestingEnabled: false,
    };
  }
}

const Singleton = new FCCopenhagenFlavor();
export default Singleton;
